// Actions constants should be mapped in the same order
// as they are defined in the actions file.
export const ACTIONS = {
  SET_DELIVERY_ADDRESSES: 'set_delivery_addresses',
  DELETE_DELIVERY_ADDRESS: 'delete_delivery_address',
  SET_DELIVERY_ADDRESSES_FAILED: 'set_delivery_addresses_failed'
};
